import SortDirectionControl from './SortDirectionControl';
import React from 'react';
import { Popover, Button, Icon, Input } from 'antd';

export const UsageUrl = ({ onChange, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center' }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        <SortDirectionControl order={params?.order} />
      </div>
      <Input
        value={params?.value}
        placeholder='Usage URL'
        style={{ width: '150px' }}
        onChange={(e) => {
          onChange({ ...params, value: e.target.value });
        }}
        allowClear
      ></Input>
    </>
  );

  return (
    <Popover content={content} title='Usage URL' trigger='click'>
      <Button className='sighting-filter' style={{ width: '12%' }}>
        Usage URL
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
